import { render, staticRenderFns } from "./whatsnew.vue?vue&type=template&id=bf710be6&"
import script from "./whatsnew.vue?vue&type=script&lang=js&"
export * from "./whatsnew.vue?vue&type=script&lang=js&"
import style0 from "./whatsnew.vue?vue&type=style&index=0&id=bf710be6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports